import api from "../api";
const url = "/shop";

export default {
  getPublicationItems(type, filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/publications/${type}/` + query);
  },
  setPublicationPrice(slug, payload) {
    return api.post(`${url}/publications/${slug}/setPrice`, payload);
  },
  uploadDigitalPublicationFiles(slug, payload) {
    return api.post(`${url}/publications/${slug}/fileupload`, payload, {
      mimeType: "multipart/form-data"
    });
  },
  getInvoices(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/orders/publisher-invoices/` + query);
  },
  getInvoiceDetail(invoiceId) {
    return api.get(`${url}/orders/publisher-invoices/${invoiceId}/`);
  },
  getPublication(id) {
    return api.get(`${url}/publications/${id}/`);
  },
  getClaims(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/claims/` + query);
  },
  getClaim(claimId) {
    return api.get(`${url}/claims/${claimId}`);
  },
  // sendMessage(claimId, payload) {
  //   return api.post(`${url}/claims/${claimId}/messages/`, payload);
  // },
  sendMessage(claimId, payload, payload_without_image, image) {
    if (image != null){
      return api.post(`${url}/claims/${claimId}/messages/`, payload , {
        mimeType: "multipart/form-data"
      });
    }else{
      return api.post(`${url}/claims/${claimId}/messages/`, payload_without_image);
    }
  },
  exportList(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/orders/publisher-orders/exportXlsx` + query);
  },
  downloadFile(fileName) {
    return api.get(`${url}/orders/downloadReport/${fileName}`, {
      responseType: "blob"
    });
  },
  getOrders(invoiceId, filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(
      `${url}/orders/publisher-invoices/${invoiceId}/publisher-orders/` + query
    );
  },
  updateInvoiceStatus(invoiceId, payload) {
    return api.post(
      `${url}/orders/publisher-invoices/${invoiceId}/setStatus`,
      payload
    );
  },
  updateOrderStatus(orderId, invoiceId, payload) {
    return api.post(
      `${url}/orders/publisher-invoices/${invoiceId}/publisher-orders/${orderId}/setStatus`,
      payload
    );
  },
  getActivePublications(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/orders/publisher-invoices/getActivates` + query);
  },
  getEndedPublications(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/orders/publisher-invoices/getDeactivates` + query);
  },
  getReport(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/orders/publisher-orders/` + query);
  },
  updateInvoiceDetail(invoiceId, payload) {
    return api.patch(`${url}/orders/publisher-invoices/${invoiceId}/`, payload);
  },
  allOrders(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/orders/publisher-orders/all` + query);
  },
  getTicket(query) {
    return api.get(`${url}/orders/publisher-orders/print` + query);
  },
  allPrints(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/orders/publisher-orders/allPrints` + query);
  },
  exportInvoiceDetailPdf(invoiceId, payload) {
    return api.post(
      `${url}/orders/publisher-invoices/${invoiceId}/export_pdf`,
      payload
    );
  },
  getHistory(payload) {
    return api.get(
      `${url}/orders/publisher-orders/history?order_id=` + payload
    );
  },
};
